import { fontSizes } from "healthex-common/sizes";
import styled from "styled-components";
import { FlexColumn } from "./common.styles";
export const NotFound = styled.div `
    margin-top: 40px;
    font-size: ${fontSizes.MEDIUM};
`;
export const ResearcherStudiesDetailViewParent = styled(FlexColumn) `
    padding-top: 24px;
    gap: 24px;
`;
